import { render, staticRenderFns } from "./IncomeTotal.vue?vue&type=template&id=2f876a1c&"
import script from "./IncomeTotal.vue?vue&type=script&lang=js&"
export * from "./IncomeTotal.vue?vue&type=script&lang=js&"
import style0 from "./IncomeTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports